
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    content: [
      { path: '/diary', label: '勉強日記', title: '勉強日記 - 学習記録を見る' },
      { path: '/materials', label: '勉強資料', title: '勉強資料 - 学習資料を見る' },
      { path: '/videos', label: '講義動画', title: '講義動画 - YouTube動画を見る' },
      { path: '/quiz', label: '一問一答', title: '一問一答クイズ - 問題を解く' },
    ],
    info: [
      { path: '/contact', label: 'お問い合わせ', title: 'お問い合わせフォーム' },
      { path: '/privacy', label: 'プライバシーポリシー', title: 'プライバシーポリシーを見る' },
      { path: '/disclaimer', label: '免責事項', title: '免責事項を見る' },
    ],
  };

  return (
    <footer className="bg-gradient-to-br from-teal-600 via-teal-700 to-emerald-700 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 text-white transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* About */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 flex items-center gap-2">
              <Link to="/" title="永山の勉強アーカイブ - トップページへ" className="hover:text-teal-200 dark:hover:text-teal-400 transition-colors flex items-center gap-2">
                <i className="ri-book-open-line"></i> <strong>永山の勉強アーカイブ</strong>
              </Link>
            </h4>
            <p className="text-teal-100 dark:text-gray-400 text-xs sm:text-sm leading-relaxed">
              <strong>永山の勉強アーカイブ</strong>は、日々の学習内容を記録・整理する個人学習サイトです。<strong>勉強日記</strong>、<strong>学習資料</strong>、講義動画、一問一答クイズで効率的に復習に用いています。
            </p>
          </div>

          {/* Content Links */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">
              <strong>コンテンツ</strong>
            </h4>
            <ul className="space-y-1.5 sm:space-y-2">
              {footerLinks.content.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    title={link.title}
                    className="text-teal-100 dark:text-gray-400 hover:text-white dark:hover:text-white transition-colors text-xs sm:text-sm flex items-center gap-2 group"
                  >
                    <i className="ri-arrow-right-s-line group-hover:translate-x-1 transition-transform"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Info Links */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">
              <strong>サイト情報</strong>
            </h4>
            <ul className="space-y-1.5 sm:space-y-2">
              {footerLinks.info.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    title={link.title}
                    className="text-teal-100 dark:text-gray-400 hover:text-white dark:hover:text-white transition-colors text-xs sm:text-sm flex items-center gap-2 group"
                  >
                    <i className="ri-arrow-right-s-line group-hover:translate-x-1 transition-transform"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-teal-500/30 dark:border-gray-700 pt-5 sm:pt-8 flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
          <p className="text-teal-100 dark:text-gray-400 text-xs sm:text-sm text-center sm:text-left">
            © {currentYear} <strong>永山の勉強アーカイブ</strong>. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
